document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  function getProductDataByVariantId(variantId) {
    const script = document.querySelector(`[data-product-data][data-variant-id="${variantId}"]`);
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function getCartValue() {
    const totalSpan = document.querySelector(".totals__subtotal-value");
    if (!totalSpan) return 0;
    return parseFloat(totalSpan.textContent.trim().replace(/[€\s]/g, "").replace("EUR", "").replace(/\./g, "").replace(",", ".")) || 0;
  }

  async function extractProductId(variantId, productData) {
    let pId = productData?.product_id || productData?.featured_image?.product_id;
    if (!pId && productData?.variants) pId = productData.id;
    if (pId) return String(pId);

    try {
      const variantInput = document.querySelector(`input[name="id"][value="${variantId}"], select[name="id"] option[value="${variantId}"]`);
      if (variantInput) {
        const form = variantInput.closest('form');
        if (form) {
          const productInput = form.querySelector('input[name="product-id"], input[name="product_id"]');
          if (productInput && productInput.value) return String(productInput.value);
        }
      }
    } catch(e) {}

    try {
      const res = await fetch('/cart.js');
      const cartData = await res.json();
      if (cartData && cartData.items) {
        const cartItem = cartData.items.find(item => item.variant_id.toString() === variantId.toString());
        if (cartItem && cartItem.product_id) return String(cartItem.product_id);
      }
    } catch(e) {}

    if (window.meta?.product?.id) return String(window.meta.product.id);
    if (window.ShopifyAnalytics?.meta?.product?.id) return String(window.ShopifyAnalytics.meta.product.id);

    if (window.location.pathname.includes('/products/')) {
      try {
        const res = await fetch(window.location.pathname.split('?')[0] + '.js');
        const data = await res.json();
        if (data.id) return String(data.id);
      } catch(e) {}
    }

    return "undefined";
  }

  async function pushAddToCartEvent(variantId) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;
    
    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const discount = Math.max(0, maxPrice - finalPrice);
    const cartData = getCartValue();
    
    let quantity = 1;
    const input = document.querySelector(`.quantity__input[data-quantity-variant-id="${variantId}"]`);
    if (input && input.value) quantity = parseInt(input.value, 10) || 1;

    const productId = await extractProductId(variantId, productData);
    const itemId = (productId !== "undefined" && productId != null) ? `shopify_ZZ_${productId}_${variantId}` : `shopify_ZZ_undefined_${variantId}`;
  }

  async function pushRemoveFromCartEvent(variantId, quantityOverride) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;
    
    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const cartData = getCartValue();
    const discount = Math.max(0, maxPrice - finalPrice);
    
    let quantity = typeof quantityOverride === "number" ? quantityOverride : 1;
    if (typeof quantityOverride !== "number") {
      const input = document.querySelector(`.quantity__input[data-quantity-variant-id="${variantId}"]`);
      if (input && input.value) quantity = parseInt(input.value, 10) || 1;
    }

    const productId = await extractProductId(variantId, productData);
    const itemId = (productId !== "undefined" && productId != null) ? `shopify_ZZ_${productId}_${variantId}` : `shopify_ZZ_undefined_${variantId}`;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: productData.currency,
        value: cartData,
        items: [{
            item_name: productData.title,
            item_id: itemId,
            price: finalPrice,
            item_brand: productData.vendor,
            quantity: quantity,
            discount: discount,
          }]
      }
    });
  }

  cartDrawer.addEventListener("click", function (e) {
    const plusBtn = e.target.closest(".plusAddToCartMiniCart");
    const minusBtn = e.target.closest(".minusRemoveFromMiniCart");
    const removeBtn = e.target.closest(".cart-item__remove");
    
    if (plusBtn && plusBtn.dataset.variantId) {
      pushAddToCartEvent(plusBtn.dataset.variantId);
    }

    if (removeBtn && removeBtn.dataset.variantId) {
      const input = removeBtn.closest(".cart-item, tr.cart-item")?.querySelector(".quantity__input");
      let quantity = input && input.value ? parseInt(input.value, 10) || 1 : 1;
      pushRemoveFromCartEvent(removeBtn.dataset.variantId, quantity);
    }

    if (minusBtn && minusBtn.dataset.variantId) {
      pushRemoveFromCartEvent(minusBtn.dataset.variantId, 1);
    }
  });
});